import { LoginMainFooterBandItem, LoginPage } from '@patternfly/react-core'
import * as React from 'react'
import { NavLink } from 'react-router-dom'

import bgImgSrcSm from '@app/assets/images/intake-login-bg-sm.png'
import bgImgSrcXSm from '@app/assets/images/intake-login-bg-xsm.png'
import bgImgSrc from '@app/assets/images/intake-login-bg.png'
import logoImgSrc from '@app/assets/images/intake-logo-landing.png'

export const NotFoundScreen = () => {
  const returnToLoginPage = (
    <LoginMainFooterBandItem>
      <NavLink exact to={'/'} activeClassName="pf-m-current">
        Return to the application.
      </NavLink>
    </LoginMainFooterBandItem>
  )

  const images = {
    lg: bgImgSrc,
    sm: bgImgSrcSm,
    sm2x: bgImgSrcSm,
    xs: bgImgSrcXSm,
    xs2x: bgImgSrcXSm,
  }

  return (
    <LoginPage
      brandImgSrc={logoImgSrc}
      loginTitle="Not Found!"
      loginSubtitle={
        "The page you're looking for either no longer exists or has been moved."
      }
      forgotCredentials={returnToLoginPage}
      backgroundImgSrc={images}
    />
  )
}
